export default __webpack_public_path__ + "static/media/plusBranco.545183ce.svg";